import {createAction, props} from '@ngrx/store';
import {Update} from '@ngrx/entity';

import {VerifyAdvocateFromTls} from './verify-advocate-from-tls.model';

export const loadVerifiedAdvocate = createAction(
    '[VerifyAdvocateFromTls/API] Load VerifiedAdvocate',
    props<{ VerifiedAdvocate: VerifyAdvocateFromTls[] }>()
);

export const addVerifiedAdvocate = createAction(
    '[VerifyAdvocateFromTls/API] Add VerifyAdvocateFromTls',
    props<{ VerifyAdvocateFromTls: VerifyAdvocateFromTls }>()
);

export const upsertVerifiedAdvocate = createAction(
    '[VerifyAdvocateFromTls/API] Upsert VerifyAdvocateFromTls',
    props<{ VerifyAdvocateFromTls: VerifyAdvocateFromTls }>()
);

export const addVerifiedAdvocates = createAction(
    '[VerifyAdvocateFromTls/API] Add VerifiedAdvocate',
    props<{ VerifiedAdvocate: VerifyAdvocateFromTls[] }>()
);

export const upsertVerifiedAdvocates = createAction(
    '[VerifyAdvocateFromTls/API] Upsert VerifiedAdvocate',
    props<{ VerifiedAdvocate: VerifyAdvocateFromTls[] }>()
);

export const updateVerifiedAdvocate = createAction(
    '[VerifyAdvocateFromTls/API] Update VerifyAdvocateFromTls',
    props<{ VerifyAdvocateFromTls: Update<VerifyAdvocateFromTls> }>()
);

export const updateVerifiedAdvocates = createAction(
    '[VerifyAdvocateFromTls/API] Update VerifiedAdvocate',
    props<{ VerifiedAdvocate: Update<VerifyAdvocateFromTls>[] }>()
);

export const deleteVerifiedAdvocate = createAction(
    '[VerifyAdvocateFromTls/API] Delete VerifyAdvocateFromTls',
    props<{ id: string }>()
);

export const deleteVerifiedAdvocates = createAction(
    '[VerifyAdvocateFromTls/API] Delete VerifiedAdvocate',
    props<{ ids: string[] }>()
);

export const clearVerifiedAdvocate = createAction(
    '[VerifyAdvocateFromTls/API] Clear VerifiedAdvocate'
);

export const saveVerifiedAdvocate = createAction(
    '[VerifyAdvocateFromTls/API] Save Work Experience',
    props<{ VerifyAdvocateFromTls: any }>()
);


export const verifyAdvocate = createAction(
    '[VerifyAdvocateFromTls/API] Verify VerifyAdvocateFromTls',
    props<{ VerifyAdvocateFromTls: VerifyAdvocateFromTls }>()
);


